import React from 'react';
import {
  columnType,
  columnInfo,
  columnSize,
  columnTransferable,
  hasColumn,
} from '@/constants/fields';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import TableSortedColumn from '@/components/table/TableSortedColumn';
import { ATTACHMENT_TRANSFER } from '@/datasets/attachments/constants';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const selectedOrMandatory = (items) => items.map(({ selected, metadata: { transferable } }) => ({
  selected: selected || transferable === ATTACHMENT_TRANSFER.required.name,
}));

const RequestAttachmentsTableColumns = ({
  attachments,
  category,
  code,
  columns,
}) => {
  const { isRoot, orderBy } = Selectors.useRequestAttachmentsTableColumns({ category, code });
  const onOrderByColumn = Events.useToggleRequestAttachmentColumnOrderBy(category, { code });
  const onCheckBoxClick = Events.useToggleRequestAttachmentsSelected(category, { code });

  return (
    <NameDescriptionColumns
      category="attachments"
      columns={columns}
      items={selectedOrMandatory(attachments)}
      onCheckBoxClick={isRoot ? onCheckBoxClick : undefined}
      onOrderByColumn={onOrderByColumn}
      orderBy={orderBy}
      singleSorting
    >
      {hasColumn(columns, columnType) && (
        <TableSortedColumn
          name={columnType}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
          singleSorting
          sortable
        />
      )}
      {hasColumn(columns, columnSize) && (
        <TableSortedColumn
          name={columnSize}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
          singleSorting
          sortable
        />
      )}
      {hasColumn(columns, columnTransferable) && (
        <TableSortedColumn
          name={columnInfo}
          onOrderByColumn={onOrderByColumn}
          orderBy={orderBy}
          singleSorting
          sortable
        />
      )}
    </NameDescriptionColumns>
  );
};

export default RequestAttachmentsTableColumns;
